import styled from 'styled-components'
import PropTypes from 'prop-types'
import Wrapper from 'common/wrapper'
import { useLessons } from 'querys/lesson'
import { useBadge, useCourse } from 'querys/course'
import Module from './module'

const LessonListStyled = styled.div`
  .chapter-list-container {
    display: flex;
  }
  .learning-path {
    position: relative;
    min-width: 36px;
    margin-right: 16px;
    &::before {
      position: absolute;
      margin: 0 auto;
      right: 0;
      top: 8px;
      bottom: -16px;
      left: 0;
      width: 2px;
      content: '';
      background: var(--white);
    }
    .dot {
      position: absolute;
      top: 8px;
      border-radius: 50%;
      background: var(--turquoise);
      content: '';
      margin: 0 auto;
      right: 0;
      left: 0;
      width: 8px;
      height: 8px;
    }
  }
  @media (min-width: 768px) {
    .learning-path {
      min-width: 64px;
      margin-right: 38px;
    }
    .learning-path {
      &::before {
        width: 4px;
      }
      .dot {
        width: 16px;
        height: 16px;
      }
    }
  }
`

function LesonsList() {
  const { data: { stats: { num_lessons: totalLessons }, course_progress: courseProgress } } = useCourse()
  const { data: chapters, isLoading } = useLessons()
  const { data, isError } = useBadge()

  if (isLoading || isError) return null

  let { badge, badge_states } = data

  const allCompleted = courseProgress?.progress === 100 ? courseProgress.total + 1 : 0
  const lessonsCompletedArr = chapters.map((chapter) => chapter.lessons.map((lesson) => lesson.completed))

  // ¿Until witch lesson are all completed?, If all completed, findIndex will return 0 again
  const lessonsCompleted = allCompleted || lessonsCompletedArr.flat().findIndex((completed) => completed === false) + 1

  const badgeStep = Math.floor(totalLessons / 4)
  const restLessons = totalLessons % 4

  // Recreate the badges array adding a key to know in which lesson are assigned
  const badges = badge_states.slice(0, 4).map((badge, idx) => {
    const badgePosition = badgeStep * (idx + 1)
    if (idx === 3) return { ...badge, lesson: badgePosition + restLessons }
    return { ...badge, lesson: badgePosition }
  })

  // Extract the lesson positions from the badges
  const lessonsWidthBadge = badges.map((badge) => badge.lesson)

  // Who should show progress in the course
  const lessonWidthBadge = lessonsWidthBadge.find((item) => item >= lessonsCompleted)

  return (
    <LessonListStyled id="chapter-list">
      <Wrapper maxWidth="1200">
        <div className="chapter-list-container">
          {badges.length >= 4 && (
            <div className="learning-path">
              <div className="dot" />
            </div>
          )}
          <main className="grid">
            {chapters.map(({ uuid, title, lessons }, idx) => (
              <Module
                consecutiveLessonsCompleted={lessonsCompleted}
                progress={courseProgress?.progress}
                lessonWidthBadge={lessonWidthBadge}
                chapterIdx={idx}
                badges={badges.length < 4 ? [] : badges}
                key={uuid}
                title={title}
                classes={lessons}
              />
            ))}
          </main>
        </div>
      </Wrapper>
    </LessonListStyled>
  )
}

LesonsList.defaultProps = {
  course_progress: {
    completed: 0,
    progress: 0,
    total: 48,
  },
}

LesonsList.propTypes = {
  course_progress: PropTypes.shape({
    completed: PropTypes.number,
    progress: PropTypes.number,
    total: PropTypes.number,
  }),
}

export default LesonsList
